module.exports = __webpack_public_path__ + "img/hero-books.44fc38fa.jpg";